const formatINR = (value = 0, decimals = 2) =>
  Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

export function FarmerCard({ farmer }) {

  const old = farmer.oldAmounts || {};
  const nagadList = Array.isArray(farmer.nagadAmounts)
    ? farmer.nagadAmounts.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate))
    : [];

  return (
    <div className="farmer-card">
      <div className="card-header">
        <strong>Neeraj Dairy N. Keshiya</strong>
        <div>M: 9719328024, 8433151212</div>
      </div>

      <div className="farmer-info">
        <div>
          <strong>({farmer.code}) {farmer.firstName} {farmer.lastName}</strong>
        </div>
        <div>
          Old Amount: ₹ {formatINR(old.oldAmount > 0 ? old.oldAmount : 0)}
        </div>
      </div>

      <table className="ledger-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>To Person</th>
            <th>Reason</th>
            <th className="text-right">Amount</th>
          </tr>
        </thead>

        <tbody>
          {nagadList.map((n, index) => (
            <tr
              key={`${farmer.id || farmer.code}-${n.id ?? n.createdDate ?? index}`}
            >
              <td>{new Date(n.createdDate).toLocaleDateString()}</td>
              <td>{n.toPerson}</td>
              <td>{n.reason}</td>
              <td className="text-right">
                ₹ {formatINR(n.amount)}
              </td>
            </tr>
          ))}

          <tr>
            <td colSpan={3}><strong>Total Amount</strong></td>
            <td className="text-right">
              ₹ {formatINR(old.nagadAmount)}
            </td>
          </tr>

          <tr>
            <td colSpan={2}><strong>Interest Rate</strong></td>
            <td colSpan={2}>{old.interestRate}%</td>
          </tr>

          <tr>
            <td colSpan={2}><strong>Interest Month</strong></td>
            <td colSpan={2}>{old.interestMonth}</td>
          </tr>

          <tr>
            <td colSpan={3}><strong>Nagad</strong><span style={{ fontSize: '7px' }}> Int</span></td>
            <td className="text-right">
              ₹ {formatINR(old.interestAmount)}
            </td>
          </tr>

          <tr>
            <td colSpan={3}><strong>G Total Amount</strong></td>
            <td className="text-right">
              ₹ {formatINR(Math.abs(old.totalAmount))}
            </td>
          </tr>

          <tr>
            <td colSpan={3}><strong>Milk Price</strong></td>
            <td className="text-right">
              ₹ {formatINR(old.milkAmount)}
            </td>
          </tr>

          <tr>
            <td colSpan={2}><strong>Milk Qty</strong></td>
            <td colSpan={2}>{old.milkQty} Ltr</td>
          </tr>

          <tr>
            <td colSpan={2}><strong>Milk Rate</strong></td>
            <td colSpan={2}>{old.milkRate}</td>
          </tr>

          <tr>
            <td colSpan={3}><strong>Save Money</strong></td>
            <td className="text-right">
              ₹ {
                formatINR(Math.abs(old.saveMoney))
              }

            </td>
          </tr>

          <tr>
            <td colSpan={3}>
              <strong>Pending Price</strong>
              <span style={{ float: "right" }}>
                <b>
                  {old?.createdOn
                    ? (() => {
                      const d = new Date(old.createdOn);
                      const day = String(d.getDate()).padStart(2, "0");
                      const month = String(d.getMonth() + 1).padStart(2, "0");
                      const year = d.getFullYear();
                      return `${day}/${month}/${year}`;
                    })()
                    : ""}

                </b>
              </span>
            </td>

            <td className="text-right">
              ₹ {formatINR(old.grandTotalAmount)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
